import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { getApp } from 'owa-config';

export function canDisableLPC(): boolean {
    // LPC can have multiple entry points
    // PersonaCardBehavior - This is disable-able through lpc-isLPCDisabled flight
    // SmartEmbeddedExpandedView - This is used by legacy People Hub and not disable-able.  It is also accessible from SmartEmbeddedExpandedViewMailModule which is the flight off path for sea-deprecateSerpTabs flight
    // onOpenLPC - StandaloneAppLpc and MetaOS path when app is in OWA/Monarch.  An umbrella conditional would be checking for Places.
    // fwk-canDisableLPC - additional flighting to limit regression risk
    return (
        isGlobalFeatureEnabled('fwk-canDisableLPC') &&
        isGlobalFeatureEnabled('lpc-isLPCDisabled') &&
        !['Places', 'People'].includes(getApp())
    );
}
